<template>
	<div class="list_board">
		<ul class="list_gallery" id="more-article-list">
			<template v-for="article in articles" v-bind="article">
				<restricted-album-article-item v-if="isRestricted(article)" v-bind="article"/>
				<album-article-item v-else v-bind="article"/>
			</template>
		</ul>
	</div>
</template>

<script>
import RestrictedAlbumArticleItem from './RestrictedAlbumArticleItem.vue'
import AlbumArticleItem from './AlbumArticleItem.vue';
import {mapState} from 'vuex';

export default {
	components: {
		RestrictedAlbumArticleItem, AlbumArticleItem
	},
	computed: {
		...mapState(['articles'])
	},
	methods: {
		isRestricted(article) {
			return !!article.vldstatus;
		}
	}
}
</script>
